import { Component, OnInit, ChangeDetectorRef, NgZone, Input, DoCheck, ViewContainerRef } from '@angular/core';
import { SpinnerService } from './service/spinner.service';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, DoCheck {
  title = 'app';
  @Input()
  objLoaderStatus = false;

  constructor(public toastr: ToastsManager,
    private router: Router,
    private loaderService: SpinnerService, private cdRef: ChangeDetectorRef, private _ngZone: NgZone, vRef: ViewContainerRef) {
    this.getRecentDetections();
    this.toastr.setRootViewContainerRef(vRef);
  }
  ngOnInit() {
  }

  getRecentDetections(): void {
    this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });

  }

  public ngDoCheck() {
    this.cdRef.detectChanges();
  }



}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/app.component.ts